import { DotLottieReact } from '@lottiefiles/dotlottie-react'
import { Box } from '@mui/material'
import useSound from 'use-sound'
import { useStoreState } from '../../../store/hooks'

export const StepResult = () => {
    const stepProgress = useStoreState((state) => state.puzzleQuestView.stepProgress)
    const settings = useStoreState((state) => state.gameView.settings)

    const [playResolve] = useSound(`/assets/sounds/default/Reward.mp3`, { volume: 0.25 })

    const { reward } = stepProgress

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                // height: '100%',
                // minHeight: '200px',
                position: 'relative',
                overflow: 'visible',
            }}
        >
            {/* Background Rays Animation */}
            <Box
                sx={{
                    position: 'absolute',
                    width: '100%',
                    height: { xs: '200%', sm: '150%', md: '200%' },
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 0,
                }}
            >
                <DotLottieReact
                    src="/assets/animations/puzzles/puzzle-quest/Rays.lottie"
                    loop={true}
                    layout={{ fit: 'contain' }}
                    renderConfig={{ autoResize: true }}
                    autoplay
                    speed={0.5}
                />
            </Box>

            {/* Crown Animation */}
            <Box
                sx={{
                    position: 'relative',
                    zIndex: 1,
                    flexGrow: 1,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <DotLottieReact
                    src={`/assets/animations/puzzles/puzzle-quest/Crowns_0${reward}.lottie`}
                    loop={false}
                    onAnimationStart={() => {
                        reward && settings.soundOn && playResolve()
                    }}
                    speed={0.7}
                    autoplay
                    layout={{ fit: 'cover' }}
                    renderConfig={{ autoResize: true }}
                />
            </Box>
        </Box>
    )
}
